import { render, staticRenderFns } from "./thirdPartyAnalysisLink.vue?vue&type=template&id=10020beb&scoped=true&"
import script from "./thirdPartyAnalysisLink.vue?vue&type=script&lang=js&"
export * from "./thirdPartyAnalysisLink.vue?vue&type=script&lang=js&"
import style0 from "./thirdPartyAnalysisLink.vue?vue&type=style&index=0&id=10020beb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10020beb",
  null
  
)

export default component.exports